import PropTypes from 'prop-types';
import { nullValidator } from './validators';

export const numberOrArrayPlusNull = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, nullValidator]))
]);
